<script setup>
const donationBlockDescription = `Мы работаем только для наших читатель:ниц.
  Вы можете помочь нам и оформить ежемесячное или разовое пожертвование`;
</script>

<template>
  <div class="act-header-card">
    <div class="act-header-card__container content-container">
      <img
        alt="Поддержать DOXA — Действуйте!"
        class="act-header-card__title"
        src="~/assets/images/act-title.svg"
      />
      <DonationBlockPayment :description="donationBlockDescription" />
    </div>
  </div>
</template>

<style lang="postcss" scoped>
.act-header-card {
  margin: calc(var(--main-header-height) * -1) 0 0;
  padding: 100px 0 0;
  border-radius: 0 0 24px 24px;
  background: linear-gradient(
    -90deg,
    rgba(255, 57, 223, 60%) 0%,
    rgba(181, 61, 255, 60%) 100%
  );

  &__container {
    padding: 90px 60px;
  }

  &__title {
    width: 100%;
    height: auto;
    margin-bottom: 90px;
  }

  @media (--small-vp) {
    &__container {
      padding: 0 12px 56px;
    }

    &__title {
      margin-bottom: 30px;
    }
  }
}
</style>
